import React from "react";
import { Helmet } from "react-helmet";

export default function MetaMaster({ title, description }) {
  return (
    <Helmet>
      {title ? <title>{title}</title> : <title>Vital'eau</title>}
      {description && <meta name="description" content={description} />}
    </Helmet>
  );
}
